export default {
    GENDER: [
        { key: 'MALE', label: "Male" },
        { key: 'FEMALE', label: "Female" },
    ],
    ROUTE_PERSONAS: {
        admin: "ADMINISTRATOR",
        telecaller: "TELECALLER",
        ops: "SALES_TEAM",
        connector: "CONNECTOR",
        agent: "AGENT",
        manager: "DIGIREP-MANAGER",
        associate: "ASSOCIATE",
        accounts: "ACCOUNTS",
        sales: "SALES",
    },
    ROUTE_PERSONAS_MAP: {
        ADMINISTRATOR: "ADMINISTRATOR",
        CONNECTOR: "DIGI REP",
        AGENT: "AGENT",
        TELECALLER: "TELECALLER",
        "DIGIREP-MANAGER": "DIGI TEAM MANAGER",
        ASSOCIATE: "ASSOCIATE",
        ACCOUNTS: "ACCOUNTS",
        SALES: "SALES",
        SALES_TEAM: "SALES_TEAM"
    },
    ROUTE_PERSONAS_REVERSE_MAP: {
        "ADMINISTRATOR": "ADMINISTRATOR",
        "DIGIREP-MANAGER": "DIGIREP-MANAGER",
        "CONNECTOR": "CONNECTOR",
        "AGENT": "AGENT",
        "TELECALLER": "TELECALLER",
        "ASSOCIATE": "ASSOCIATE",
        "ACCOUNTS": "ACCOUNTS",
        "SALES": "SALES",
        "SALES_TEAM": "SALES_TEAM",
    },
    ROUTE_PERSONAS_TEXT: {
        ADMINISTRATOR: "Admin",
        MASTER_ADMIN: "Admin",
        CONNECTOR: "Connector",
        AGENT: "Agent",
        TELECALLER: "Tele Caller",
        SALES_TEAM: "Sales Team",
    },
    ROLE_DESIGNATION_TEXT: {
        TELECALLER: "Tele Caller",
        BUSINESS_HEAD: "Business Head",
        REGIONAL_SALES_MANAGER: "Regional Sales Manager",
        AREA_SALES_MANAGER: "Area Sales Manager",
        SALES_MANAGER: "Sales Manager",
        RELATIONSHIP_MANAGER: "Relationship Manager",
        OTHERS: "Others",
    },
    ROLE_BASED_DESIGNATIONS: {
        TELECALLER: [
            { key: "TELECALLER", label: "Telecaller" },
        ],
        SALES_TEAM: [
            { key: "BUSINESS_HEAD", label: "Business Head" },
            { key: "REGIONAL_SALES_MANAGER", label: "Regional Sales Manager" },
            { key: "AREA_SALES_MANAGER", label: "Area Sales Manager" },
            { key: "SALES_MANAGER", label: "Sales Manager" },
            { key: "RELATIONSHIP_MANAGER", label: "Relationship Manager" },
            { key: "OTHERS", label: "Others" },
        ],
    },
    STATUS: [
        { key: 'active', label: "Active" },
        { key: 'inactive', label: "In Active" },
    ],
    ADMIN_LEADS_STATUS: [
        { key: 'OPEN', label: "Open" },
        { key: 'INTERESTED', label: "Interested" },
        { key: 'NOT_INTERESTED', label: "Not Interested" },
        { key: 'NOT_REACHABLE', label: "Not Reachable" },
        { key: 'CALL_NOT_ANSWERED', label: "Call Not Answered" },
    ],
    ADMIN_LEADS_STATUS_2: [
        { key: 'OPEN', label: "Open" },
        { key: 'INTERESTED', label: "Interested" },
        { key: 'NOT_INTERESTED', label: "Not Interested" },
        { key: 'NOT_REACHABLE', label: "Not Reachable" },
        { key: 'CALL_NOT_ANSWERED', label: "Call Not Answered" },
        { key: 'APPLIED', label: "Applied" },
    ],
    ENQUIRY_STATUS: [
        { key: 'APPLIED', label: "Applied" },
        { key: 'CONTACTED', label: "Contacted" },
        { key: 'NOT_CONTACTED', label: "Not Contacted" },
    ],
    LEADS_ALLOWED_STATUS: [
        "OPEN",
        "INTERESTED",
        "NOT_INTERESTED",
        "NOT_REACHABLE",
        "CALL_NOT_ANSWERED",
    ],
    OPS_LEADS_STATUS: [
        { key: "OPEN", label: "Open" },
        { key: "NOT_INTERESTED", label: "Not Interested" },
        { key: "INTERESTED", label: "Interested" },
        { key: "NOT_REACHABLE", label: "Not Reachable" },
        { key: "CALL_NOT_ANSWERED", label: "Call Not Answered" },
        { key: "PENDING", label: "Pending" },
        { key: "NOT_ELIGIBLE", label: "Not Eligible" },
        { key: "APPLIED", label: "Applied" },
    ],
    SOURCES: [
        { key: 'SELF', label: "Self" },
        { key: 'ENQUIRY', label: "Enquiry" },
        { key: 'EMPLOYEE', label: "Employee" },
        { key: 'CUSTOMER', label: "Customer" },
        { key: 'BULK', label: "Bulk" },
        { key: 'WEBSITE', label: "Website" },
    ],
    SOURCE_FILTERS: [
        { key: 'SELF', label: "Self" },
        { key: 'ENQUIRY', label: "Enquiry" },
        { key: 'EMPLOYEE', label: "Employee" },
        { key: 'BULK', label: "Bulk" },
        { key: 'CUSTOMER', label: "Customer" },
        { key: 'SOCIAL', label: "Social" },
        { key: 'META_ADS', label: "Meta Ads" },
        { key: 'WEBSITE', label: "Website" },
    ],
    LOGIN_STATUS: [
        { key: 'pending', label: "Pending" },
    ],
    STATUS_COLOR_MAP: {
        // success
        'paid': 'success',
        'interested': 'success',
        'processed': 'success',
        'live': 'success',
        'active': 'success',
        'assigned': 'success',
        'disbursed': 'success',
        'sanctioned': 'blue',
        // error
        'not_interested': 'error',
        'call_not_answered': 'error',
        'not_reachable': 'error',
        'not_eligible': 'error',
        'rejected': 'error',
        'reject': 'error',
        'unpaid': 'error',
        'failed': 'error',
        'call_back': 'error',
        'deleted': 'error',
        'closed': 'error',
        'inactive': 'error',
        // warning
        'contacted': 'warning',
        'pending': 'warning',
        'logged_in': 'warning',
        'applied': 'initial',
        'open': 'initial',
        'upcoming': 'warning',
        // approved
        'approved': 'approved',
        // 
        'login': 'purple',
        'open': 'open',
    },
    EMP_ROLE_MAP: {
        "DigiRep": ["Manager DigiRep", "Admin"],
        "Manager DigiRep": ["Admin"],
        "Admin": ["Admin"],
    },
    LOAN_TYPES: [
        { key: 'PERSONAL_LOAN', label: "Personal loan" },
        { key: 'BUSINESS_LOAN', label: 'Business loan' },
        { key: 'HOME_LOAN', label: "Home loan", },
        { key: "LOAN_AGAINST_PROPERTY", label: "Loan Against Property" },
        { key: "CAR_LOAN", label: "Car Loan" },
        { key: "GOLD_LOAN", label: "Gold Loan" },
        { key: "INSURANCE_LOAN", label: "Insurance Loan" },
        { key: "CREDIT_CARD_LOAN", label: "Credit Card Loan" },
        { key: "EDUCATION_LOAN", label: "Education Loan" },
        { key: "CORPORATE_LOAN", label: "Corporate Loan" },],

    LOAN_TYPES_MAP: {
        'PERSONAL_LOAN': 'Personal loan',
        'BUSINESS_LOAN': 'Business loan',
        'HOME_LOAN': 'Home loan',
        'LOAN_AGAINST_PROPERTY': 'Loan Against Property',
        'CAR_LOAN': 'Car Loan',
        'GOLD_LOAN': 'Gold Loan',
        'INSURANCE_LOAN': 'Insurance Loan',
        'CREDIT_CARD_LOAN': 'Credit Card Loan',
        'EDUCATION_LOAN': 'Education Loan',
        'CORPORATE_LOAN': 'Corporate Loan',
        'BALANCE_TRANSFER': 'Balance Transfer'
    },
    INTEREST_TYPES: [
        { key: 'Fixed', label: 'Fixed' },
        { key: 'Floating', label: 'Floating' },
    ],
    LEADS_STATUS: [
        { key: 'interested', label: "Interested" },
        { key: 'not_interested', label: "Not Interested" },
        { key: 'not_reachable', label: "Not Reachable" },
        { key: 'call_not_answered', label: "Call Not Answered" },
    ],
    LOAN_STATUS: [
        { key: 'APPLIED', label: "Applied" },
        { key: 'APPROVED', label: "Approved" },
        { key: 'DISBURSED', label: "Disbursed" },
    ],
    APPLICATION_LOAN_STATUS: [
        { key: "LOGIN", label: "Login" },
        { key: "SANCTIONED", label: "Sanctioned" },
        { key: "DISBURSED", label: "Disbursement" },
        { key: "REJECTED", label: "Rejected" },
        { key: "OTHERS", label: "Others" },
    ],
    AGENT_APPLICATION_STATUS: [
        { key: "ASSIGNED", label: "Assigned" },
        { key: "PENDING", label: "Pending" },
        { key: "DISBURSED", label: "Disbursement" },
        { key: "REJECTED", label: "Rejected" },
    ],
    LOAN_STATUS_NEW: [
        { key: 'OPEN', label: "Open" },
        { key: 'APPLIED', label: "Applied" },
        { key: 'DISBURSED', label: "Disbursed" },
        { key: 'CONTACTED', label: "Contacted" },
        { key: 'NOT_ELIGIBLE', label: "Not Eligible" },
    ],
    LOAN_STATUS_MAP: {
        applied: "APPLIED",
        approved: "APPROVED",
        disbursed: "DISBURSED",
        open: "OPEN",
        contacted: "CONTACTED",
        noteligible: "NOT_ELIGIBLE"
    },
    LEAD_TITLE_MAP: {
        "lt_finance": "L&T Finance",
        "tata_capital": "Tata Capital",
        "incred_finance": "InCred Finance",
        "zype": "Zype",
    },
    CHANNEL_TYPES: [
        { key: "ONLINE", label: "Online" },
        { key: "OFFLINE", label: "Offline" },
    ],
    // OFFLINE_TITLE_MAP: {
    //     "personal_loan":"Personal Loan",
    // },
    REGEX: {
        email: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        number: /^[0-9]+$/,
        onlystring: /^[A-Za-z\s]*$/,
        pan: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
        degrees: /^[0-9-+.]*$/,
        float: /^[0-9.]*$/,
        ifsc: /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/,
    },
    EMPLOYEE_TYPE: [
        { key: 'Salaried', label: "Salaried" },
        { key: 'Self Employed', label: "Self Employed" },
    ],
    LEAD_EMPLOYEE_TYPE: [
        { key: "SALARIED", label: "Salaried" },
        { key: "SELF_EMPLOYED", label: "Self Employed" },
        { key: "PROFESSIONAL", label: "Professional" },
        { key: "OTHERS", label: "Others" },
    ],
    BANKWISE_EMPLOYEE_TYPE: [
        { key: 'SALARIED', label: "Salaried" },
        { key: 'SELF_EMPLOYED', label: "Self Employed" },
    ],
    TENURE: [
        { key: 6, label: "6 Months" },
        { key: 12, label: "12 Months" },
        { key: 18, label: "18 Months" },
        { key: 24, label: "24 Months" },
        { key: 30, label: "30 Months" },
        { key: 36, label: "36 Months" },
        { key: 42, label: "42 Months" },
        { key: 48, label: "48 Months" },
        { key: 54, label: "54 Months" },
        { key: 60, label: "60 Months" },
    ],
    BANK_WISE_TENURE: [
        { key: 6, label: "6 Months" },
        { key: 12, label: "12 Months" },
        { key: 18, label: "18 Months" },
        { key: 24, label: "24 Months" },
        { key: 30, label: "30 Months" },
        { key: 36, label: "36 Months" },
        { key: 42, label: "42 Months" },
        { key: 48, label: "48 Months" },
        { key: 54, label: "54 Months" },
        { key: 60, label: "60 Months" },
        { key: 66, label: "66 Months" },
        { key: 72, label: "72 Months" },
        { key: 78, label: "78 Months" },
        { key: 84, label: "84 Months" },
    ],
    BANK_WISE_PROCESS: [
        { key: 'Digital', label: "Digital" },
        { key: 'Offline', label: "Offline" },

    ],
    PAYOUT_TYPES: [
        { key: "monthly", label: "Monthly" },
        { key: "spot", label: "Spot" },
    ],
    ADMIN_PAYOUT_STATUS: [
        { key: "PENDING", label: "Pending" },
        { key: "PROCESSED", label: "Processed" },
    ],
    PAYOUT_STATUS: [
        { key: "PENDING", label: "Pending" },
        { key: "PROCESSED", label: "Processed" },
        { key: "UNPAID", label: "Unpaid" },
        { key: "PAID", label: "Paid" },
        { key: "REJECTED", label: "Rejected" },
    ],
    ADMIN_KYC_REQUEST_STATUS: [
        { key: "PROCESSED", label: "Processed" },
        { key: "PENDING", label: "Pending" },
        { key: "REJECT", label: "Reject" },
    ],
    ALL_PAYOUT_STATUS: [
        { key: "PENDING", label: "Pending" },
        { key: "PROCESSED", label: "Processed" },
        { key: "UNPAID", label: "Unpaid" },
        { key: "PAID", label: "Paid" },
    ],
    SALARY_RANGE: [
        { key: "Less than Rs.3Lac", label: "Less than Rs.3Lac" },
        { key: "Rs. 3 to 5 Lac", label: "Rs. 3 to 5 Lac" },
        { key: "Rs. 5 to 10 Lac", label: "Rs. 5 to 10 Lac" },
        { key: "Rs. 10 to 15 Lac", label: "Rs. 10 to 15 Lac" },
        { key: "Rs. 15 to 20 Lac", label: "Rs. 15 to 20 Lac" },
        { key: "Greater than 25 Lac", label: "Greater than 25 Lac" },
    ],
    RESIDENCE_OWNERSHIP: [
        { key: "rented", label: "Rented" },
        { key: "owned", label: "Owned" }
    ],
    EDUCATION_QUALIFICATION: [
        { key: "doctor", label: "Doctor" },
        { key: "CA", label: "CA" },
        { key: "master", label: "Masters" },
        { key: "graduate", label: "Graduate" },
        { key: "non-graduate", label: "Non-graduate" },
    ],
    PAYOUT_TYPE: [
        { key: "monthly", label: "Monthly" },
        { key: "spot", label: "Spot" }
    ],
    LEADS_DETAIL: [
        { key: "today", label: "Today" },
        { key: "last_six_month", label: "Last 6 months" }
    ],
    TOTAL_WORK_EXP: [
        { key: "<1 year", label: "<1 year" },
        { key: "1-3 years", label: "1-3 years" },
        { key: "3-7 years", label: "3-7 years" },
        { key: ">7 Years", label: ">7 Years" },
    ],
    ACCOUNT_TYPE: [
        { key: "Current", label: "Current" },
        { key: "Savings", label: "Savings" }
    ],
    PRODUCT_TYPES: {
        'PERSONAL LOAN': 'PERSONAL LOAN',
        'BUSINESS LOAN': 'BUSINESS LOAN',
        'HOME LOAN': 'HOME LOAN',
        'CAR LOAN': 'CAR LOAN',
        'GOLD LOAN': 'GOLD LOAN',
        'INSURANCE LOANS': 'INSURANCE LOANS',
        'CREDIT CARD LOANS': 'CREDIT CARD LOANS',
        'EDUCATION LOANS': 'EDUCATION LOANS',
        'CORPORATE LOANS': 'CORPORATE LOANS'
    },
    RECHARGE_AMOUNTS: [
        { key: 100, label: "₹ 100" },
        { key: 1000, label: "₹ 1,000" },
        // { key: 500, label: "₹ 500" },
        // { key: 'others', label: "Others" },
    ],
    MARITAL_STATUS: [
        { key: "Single", label: "Single" },
        { key: "Married", label: "Married" },
        { key: "Divorced", label: "Divorced" }
    ],
    YES_OR_NO: [
        { key: true, label: "Yes" },
        { key: false, label: "No" },
    ],
    INCRED_MARITAL_STATUS: [
        { key: "Single", label: "Single" },
        { key: "Married", label: "Married" },
        { key: "Divorced", label: "Divorced" },
        { key: "Widowed", label: "Widowed" },
    ],
    INCRED_RESIDENCE_TYPES: [
        { key: "Hostel", label: "Hostel" },
        { key: "Owned", label: "Owned" },
        { key: "Rented", label: "Rented" },
    ],
    INCRED_PRUPOSE_OF_LOANS: [
        { key: "BUSINESS_GROWTH", label: "Business Growth" },
        { key: "BUY_CONSUMER_DURABLES", label: "Buy Consumer Durables" },
        { key: "CHILD_EDUCATION", label: "Child Education" },
        { key: "CHILD_WEDDING", label: "Child Wedding" },
        { key: "EMERGENCY", label: "Emergency" },
        { key: "FOR_VACATION", label: "For Vacation" },
        { key: "HOME RENOVATION", label: "Home Renovation" },
        { key: "INVENTORY_PURCHASE", label: "Inventory Purchase" },
        { key: "LP_OTHERS", label: "LP Others" },
        { key: "MEDICAL_EXPENSES", label: "Medical Expensed" },
        { key: "OWN_WEDDING", label: "Own Wedding" },
        { key: "PRE_PAYMENT", label: "Pre Payment" },
    ],
    INCRED_GENDERS: [
        { key: 'MALE', label: "Male" },
        { key: 'FEMALE', label: "Female" },
    ],
    INCRED_EMPLOYMENT_TYPES: [
        { key: "SALARIED", label: "Salaried" },
        { key: "SELFEMP", label: "Self employed" },
        { key: "NOTEARNING", label: "Not Working" },
    ],
    INCRED_MODE_OF_SALARY: [
        { key: "cash", label: "Cash" },
        { key: "banktransfer", label: "Bank Transfer" },
    ],
    QR_LANGUAGES: [
        { key: "english", label: "English" },
        { key: "telugu", label: "Telugu" }
    ],
    MONTH_KEY_VALUE: [
        { key: 0, label: "January" },
        { key: 1, label: "February" },
        { key: 2, label: "March" },
        { key: 3, label: "April" },
        { key: 4, label: "May" },
        { key: 5, label: "June" },
        { key: 6, label: "July" },
        { key: 7, label: "August" },
        { key: 8, label: "September" },
        { key: 9, label: "October" },
        { key: 10, label: "November" },
        { key: 11, label: "December" }
    ],
    MONTH_MAP: {
        Jan: "January",
        Feb: "February",
        Mar: "March",
        Apr: "April",
        May: "May",
        Jun: "June",
        Jul: "July",
        Aug: "August",
        Sep: "September",
        Oct: "October",
        Nov: "November",
        Dec: "December"
    },
    YEAR_KEY_VALUE: [
        { key: 2000, label: "2000" },
        { key: 2001, label: "2001" },
        { key: 2002, label: "2002" },
        { key: 2003, label: "2003" },
        { key: 2004, label: "2004" },
        { key: 2005, label: "2005" },
        { key: 2006, label: "2006" },
        { key: 2007, label: "2007" },
        { key: 2008, label: "2008" },
        { key: 2009, label: "2009" },
        { key: 2010, label: "2010" },
        { key: 2011, label: "2011" },
        { key: 2012, label: "2012" },
        { key: 2013, label: "2013" },
        { key: 2014, label: "2014" },
        { key: 2015, label: "2015" },
        { key: 2016, label: "2016" },
        { key: 2017, label: "2017" },
        { key: 2018, label: "2018" },
        { key: 2019, label: "2019" },
        { key: 2020, label: "2020" },
        { key: 2021, label: "2021" },
        { key: 2022, label: "2022" },
        { key: 2023, label: "2023" },
        { key: 2024, label: "2024" },
        { key: 2025, label: "2025" },
    ],
    PAYOUT_RATE_REGIONS: [
        { key: "panindia", label: "PAN India" },
        { key: "southindia", label: "South India (AP, TG, Karnataka , Tamil Nadu,  Kerala)" },
        { key: "northeastwest", label: "North East & West" },
    ],
    PAYOUT_RATE_REGIONS_MAP: {
        panindia: "PAN India",
        southindia: "South India (AP, TG, Karnataka, Tamil Nadu, Kerala)",
        northeastwest: "North East & West",
    },
    PAYOUT_RATE_LOAN_TYPES_MAP: [
        "PL",
        "BL",
        "LAP",
        "HL",
        "SchoolFunding",
        "LoanProtector",
        "EL",
        "Equipment",
        "SecuredODDOD",
        "LAS",
        "NewCarLoan",
        "GL",
        "VehicleInsurance",
        "CommercialVehicles",
        "HealthInsurance",
        "PropertyInsurance",
        "TravelInsurance",
        "AgriLoans",
        "CreditCards",
        "MutualFunds",
        "WorkingCapital",
        "AL"
    ],
    PAYOUT_RATE_LOAN_TYPES_MAP_ENUM: {
        PL: "PERSONAL LOAN",
        BL: "BUSINESS LOAN",
        LAP: "LOAN AGAINST PROPERY",
        HL: "HOME LOAN",
        SchoolFunding: "SCHOOL FUNDING",
        LoanProtector: "LOAN PROTECTOR",
        EL: "EDUCATIONAL LOANS",
        Equipment: "EQUIPMENT",
        SecuredODDOD: "SECURED(OD & DOD)",
        LAS: "LOAN AGAINST SECURITIES",
        NewCarLoan: "New Car Loan",
        GL: "GOLD LOAN",
        VehicleInsurance: "VEHICLE INSURANCE",
        CommercialVehicles: "COMMERCIAL VEHICLES",
        HealthInsurance: "HEALTH INSURANCE",
        PropertyInsurance: "PROPERTY INSURANCE",
        TravelInsurance: "TRAVEL INSURANCE",
        AgriLoans: "AGRI LOANS",
        CreditCards: "CREDIT CARDS",
        MutualFunds: "MUTUAL FUNDS",
        WorkingCapital: "WORKING CAPITAL",
        AL: "AUTO LOANS"
    },
    OVERALL_DETAIL_KEY: {
        today: "TODAY",
        current_month: "CURR_MONTH",
        last_month: "LAST_MONTH",
        all_time: "ALL_TIME",
        custom: "CUSTOM",
    },
    OVERALL_DETAIL: [
        { key: "TODAY", label: "Today" },
        { key: "CURR_MONTH", label: "Current Month" },
        { key: "LAST_MONTH", label: "Last Month" },
        { key: "ALL_TIME", label: "All" },
        { key: "CUSTOM", label: "Custom" },
    ],
    SKIP_TITLECASE_FIELDS: [
        "application_num",
        "application_number",
        "applicationNumber",
        "applicationNo",
        "application_no",
        "applicationLeadId",
        "accountHolderBankIFSC",
        "bankName",
        "bank_name",
        "lender_bank_name",
        "accountHolderBankName",
        "email_address"
    ],
    ONLY_STRING_RULE: [
        { required: true, message: "Please enter a valid value" },
        { pattern: /^[A-Za-z\s]*$/, message: "Special characters are not allowed" },
    ],
    MOBILE_NUM_RULE: [
        { required: true, message: "Please enter mobile number" },
        { pattern: /^\d{10}$/, message: "Enter a valid 10-digit mobile number" },
    ],
    EMAIL_RULE: [
        { required: true, message: "Please enter email address" },
        { pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: "Enter a valid email address" },
    ],
    EMPLOYEE_STATUS: [
        { key: "ACTIVE", label: "Active" },
        { key: "INACTIVE", label: "Inactive" },
    ],
    APPLICATION_STATUS: [
        { key: "OPEN", label: "Open" },
        { key: "APPLIED", label: "Applied" },
        { key: "DISBURSED", label: "Disbursed" },
    ],
    APPLICATION_STATUS_ALL: [
        { key: "OPEN", label: "Open" },
        { key: "APPLIED", label: "Applied" },
        { key: "DISBURSED", label: "Disbursed" },
        { key: "SENT", label: "Processed" },
        { key: "SEND_FOR_PAYOUT", label: "Send for Payout" },
    ],
    APPLICATION_PRODUCT_TYPE: [
        { key: "HOME_LOAN", label: "Home Loan" },
        { key: "LOAN_AGAINST_PROPERTY", label: "Loan Against Property" },
    ],
    APPLICATION_SUB_PRODUCT_TYPE: [
        { key: "HOME_LOAN_RESALE", label: "Home Loan Resale" },
        { key: "HOME_LOAN_UNDER_CONSTRUCTION", label: "Home Loan Under Construction" },
        { key: "HOME_LOAN_PLOT", label: "Home Loan Plot" },
        { key: "HOME_LOAN_BALANCE_TRANSFER", label: "Home Loan Balance Transfer" },
    ],
    AGENT_LOAN_TYPES: [
        { key: "HOME_LOAN", label: "Home Loan" },
        { key: "PERSONAL_LOAN", label: "Personal Loan" },
        { key: "LOAN_AGAINST_PROPERTY", label: "Loan Against Property" },
        { key: "BALANCE_TRANSFER", label: "Balance Transfer" }
    ],
    ASSIGNED_ROLES: [
        // { key: "ADMIN", label: "Admin" },
        { key: "TELECALLER", label: "Telecaller" },
        { key: "SALES_TEAM", label: "Ops" },
    ],
}